export const industryMidData = [
  { label: "200312224 (PHP)", value: "200312224" },
  { label: "200312231 (PHP)", value: "200312231" },
  { label: "103497234 (PHP)", value: "103497234" },
  { label: "103497072 (PHP)", value: "103497072" },
  { label: "200312239 (USD)", value: "200312239" },
  { label: "200312238 (USD)", value: "200312238" },
  { label: "200312237 (USD)", value: "200312237" },
  { label: "200312240 (USD)", value: "200312240" },
  { label: "200312236 (USD)", value: "200312236" },
  { label: "102116449 (PHP)", value: "102116449" },
  { label: "102116695 (PHP)", value: "102116695" },
  { label: "102116326 (PHP)", value: "102116326" },
  { label: "102116733 (PHP)", value: "102116733" },
  { label: "102116431 (PHP)", value: "102116431" },
  { label: "103497056 (PHP)", value: "103497056" },
  { label: "103497064 (PHP)", value: "103497064" },
  { label: "11986406740 (PHP)", value: "11986406740" },
  { label: "11986372444 (USD)", value: "11986372444" },
  { label: "11986768764 (PHP)", value: "11986768764" }
];
